module.exports = __webpack_public_path__ + "img/Slice40.8c7bbdf1.png";